import { TradingOfferType } from 'types/TradingOffer';

type GetEffectiveAcceptanceSharesArgs = {
  offerType: TradingOfferType | string;
  isOwnOffer: boolean;
  offerRemaining: number;
  partnerHoldings: number | null;
};

export const getEffectiveAcceptanceShares = ({
  offerType,
  isOwnOffer,
  offerRemaining,
  partnerHoldings,
}: GetEffectiveAcceptanceSharesArgs): number => {
  const remaining = Math.max(0, offerRemaining);

  if (
    offerType === TradingOfferType.BUY &&
    !isOwnOffer &&
    partnerHoldings !== null
  ) {
    return Math.min(remaining, Math.max(0, partnerHoldings));
  }

  return remaining;
};
